var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M50.157 25.224c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5FAFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33.007 16.683a7.083 7.083 0 1 1-14.166 0 7.083 7.083 0 0 1 14.166 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5FAFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.924 23.765c-8.479 0-15.474 6.355-16.482 14.563H28.97m11.9-8.415a5.676 5.676 0 0 0-5.676-5.677 5.676 5.676 0 0 0-5.154 8.06c.497 1.835 5.117 6.032 5.117 6.032s3.677-3.339 4.824-5.362c.564-.882.89-1.93.89-3.053z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5FAFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M37.587 29.913a2.392 2.392 0 1 1-4.785 0 2.392 2.392 0 0 1 4.785 0"
  }))));
};
export default SvgAddress;